import { useTranslation } from 'react-i18next';

import type { Contact, OrganisationClient } from '~/api/clients/types';

import { useDeleteContact } from '~/api/clients';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  client: OrganisationClient;
  contact: Contact;
  onClose: () => void;
};

export const ConfirmDeleteContactDialog = ({ client, contact, onClose }: Props) => {
  const mutation = useDeleteContact(client.id, contact.id);

  const { t } = useTranslation(['clients', 'common']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('clients:detail.contacts.delete.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('clients:detail.contacts.delete.description', { name: contact.fullName })}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => {
                onClose();
                toast.success({ description: t('clients:alerts.successContactDeleted') });
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('clients:detail.contacts.delete.submit')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
